import { z } from 'zod';

import { uuidValidator } from '../../validators';

export const DeleteWordsSchema = z.object({
  ids: z.array(uuidValidator).min(1, 'At least one word ID must be provided'),
});

export type IDeleteWordsDto = z.infer<typeof DeleteWordsSchema>;
